import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { visualizerActions, uiActions } from '../../store';


import styles from './Visualizer.module.css';

export default function Visualizer() {
    const urlParams = useParams();
    const dispatch = useDispatch();

    const vizLoading = useSelector((state) => state.ui.vizLoading);
    let sel = useSelector((state) => state.visualizer.selString);

    useEffect(() => {
        document.getElementById("chamViz").addEventListener('ready', function (result) {
            let surfaceData = structuredClone(result.value);
            let saveData = document.getElementById('chamViz').getSaveData();
            dispatch(visualizerActions.setSpecifier(saveData.specifier));
            dispatch(visualizerActions.setSurfaceList(surfaceData));
            document.getElementById("chamViz").useMouseovers = false;
        });

        document.getElementById("chamViz").addEventListener('surface_apply_done', function (result) {
            let saveData = document.getElementById('chamViz').getSaveData();
            dispatch(visualizerActions.setSelString(saveData.sel));
            dispatch(uiActions.setVizLoading(false))
        });

        document.getElementById('chamViz').load(urlParams.specifier, "-1");
    }, [urlParams.specifier, dispatch])

    const handleUndo = function () {
        //dispatch(uiActions.setVizLoading(true));
        document.getElementById("chamViz").undo();
    }

    const handleRedo = function () {
        //dispatch(uiActions.setVizLoading(true));
        document.getElementById("chamViz").redo();
    }

    const handleRotate = function () {
        dispatch(uiActions.setVizLoading(true));
        if (sel.indexOf("254252") !== -1) {
            sel = sel.replace("254252", "254253");
        }
        else if (sel.indexOf("254253") !== -1) {
            sel = sel.replace("254253", "254254");
        }
        else if (sel.indexOf("254254") !== -1) {
            sel = sel.replace("254254", "254255");
        }
        else if (sel.indexOf("254255") !== -1) {
            sel = sel.replace("254255", "254252");
        }
        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            if (this.type === "FLOOR") return sel;
        });
    }

    return (
        <div className={`${styles.vizContainer} ${vizLoading?styles.loading:''}`}>
            <div className={styles.loadingScreen}>Loading...</div>
            <div className={styles.flexRow}>
            <div className={styles.undo} onClick={handleUndo} >undo</div>
            <div className={styles.redo} onClick={handleRedo} >redo</div>
            <div className={styles.rotate} onClick={handleRotate} >rotate floor</div>
            </div>
            <cham-viz id="chamViz" spec="" width="1024" active="1"></cham-viz>
        </div>
    );
}